"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ee20b9p0"
} : {
  target: "ee20b9p0",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("position:fixed;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;overflow:hidden;background:", props.lightTheme ? props.theme.lightMenuBackground : props.theme.defaultMenuBackground, ";width:", props.open ? '250px' : '56px', ";height:calc(100vh - 20px);box-shadow:2px 0 20px 0 rgba(0, 0, 0, 0.05);z-index:90;padding-top:20px;transition:width 0.2s ease-in-out;@media screen and (max-width: ", _breakpoints.default.medium, "){padding:0;position:unset;display:block;overflow:unset;overflow-x:scroll;width:100%;height:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));